// extracted by mini-css-extract-plugin
export default {"container":"IPM_container__joheo"};